import type { BaseMap } from 'tg-map-core'
import { defineComponent } from 'vue'
import { callHook, createEmptyVNode } from '../utils/vue-utils'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { useTgMapInner } from './map-hooks'

export const MIXIN_MAP_NAME = '$map'
export const MIXIN_HOOK_CREATE = 'onCreate'
export const MIXIN_HOOK_DESTROY = 'onDestroy'

declare module 'vue' {
  interface ComponentCustomProperties {
    /** 混合了MapMixin的Vue才会有该属性 */
    [MIXIN_MAP_NAME]: BaseMap,
    /** 混合了MapMixin的Vue才会有该属性, 会依次调用onDestroy + onCreate, 你应该在这两个hook中分别实现 移除 和 创建并添加 覆盖物的逻辑 */
    recreate: () => void,
  }

  interface ComponentCustomOptions {
    [MIXIN_HOOK_CREATE]?(): void
    [MIXIN_HOOK_DESTROY]?(): void
  }
}

/** @deprecated 使用{@link useTgMapInner}替代 */
const MapMixin = defineComponent({
  inject: [MIXIN_MAP_NAME],
  mounted() {
    // children先执行, parent后执行
    // parent中可以读取到this.$children, 参见: TgMarkerClusterer
    callHook(this, MIXIN_HOOK_CREATE)
  },
  beforeUnmount() {
    // parent先执行, children后执行
    callHook(this, MIXIN_HOOK_DESTROY)
  },
  methods: {
    recreate() {
      callHook(this, MIXIN_HOOK_DESTROY)
      callHook(this, MIXIN_HOOK_CREATE)
    },
  },
  render() {
    return createEmptyVNode()
  },
})

export default MapMixin
